/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

 import React from 'react'

import { Col, Row } from 'reactstrap'

import ReactTable from 'react-table-legacy'
import "react-table-legacy/react-table.css";

import { css } from '@emotion/react';
import { RingLoader } from 'react-spinners'

import {AppContext} from '../../AppContext';

import prettyBytes from 'pretty-bytes';

class ObjectGatewayHistory extends React.Component
{

  debouncedSaveColumnWidths = null;
  columnKey = 'objectGatewayHistory.columnWidths';
  columnWidths = {};

  detailColumns =
  [
    {Header: 'Open Timestamp', id: 'openTimestamp', accessor: d => {return d.openTimestamp},
      Cell: rowInfo => (<div><span title={window.formatTimestamp(rowInfo.row.openTimestamp, true)}>{window.formatTimestamp(rowInfo.row.openTimestamp, false)}</span></div>)},
    {Header: 'Close Timestamp', id: 'closeTimestamp', accessor: d => {return d.closeTimestamp},
      Cell: rowInfo => (<div><span title={window.formatTimestamp(rowInfo.row.closeTimestamp, true)}>{window.formatTimestamp(rowInfo.row.closeTimestamp, false)}</span></div>)},
    {Header: 'Bytes Read', id: 'bytesRead', accessor: 'bytesRead',
      Cell: row => (<div><span title={new Intl.NumberFormat().format(parseInt(row.value, 10)) + ' Bytes'}>{prettyBytes(parseInt(row.value, 10))}</span></div>),
      sortMethod: (a, b, desc) =>
      {
        if (a > b)
          return 1;
        else
          return -1;
      }
    },
    {Header: 'Bytes Written', id: 'bytesWritten', accessor: 'bytesWritten',
      Cell: row => (<div><span title={new Intl.NumberFormat().format(parseInt(row.value, 10)) + ' Bytes'}>{prettyBytes(parseInt(row.value, 10))}</span></div>),
      sortMethod: (a, b, desc) =>
      {
        if (a > b)
          return 1;
        else
          return -1;
      }
    }
  ];

  componentDidMount()
  {
    this.columnWidths = this.context.appLocalStorage.getColumnWidths(this.state.columns, this.columnKey);
    document.title = this.context.websiteProfile.profileName + ': Gateway History'
    this.fetchObjectGatewayHistory();
  }

  constructor(props)
  {
    super();

    let columns = 
    [
      {Header: 'Creation Date', id: 'creationDate', accessor: d => {return d.creationDate}, 
        Cell: rowInfo => (<div><span title={window.formatTimestamp(rowInfo.row.creationDate, true)}>{window.formatTimestamp(rowInfo.row.creationDate, false)}</span></div>)},
      {Header: 'Last Access', id: 'lastAccess', accessor: d => {return d.lastAccess}, 
        Cell: rowInfo => (<div><span title={window.formatTimestamp(rowInfo.row.lastAccess, true)}>{window.formatTimestamp(rowInfo.row.lastAccess, false)}</span></div>)},
      {Header: 'Access Mode', id: 'accessMode', accessor: d => { return d.accessMode},
        Cell: rowInfo =>(<div>{this.formatAccessMode(rowInfo.row.accessMode)}</div>)},
      {Header: 'Access Count', id: 'accessCount', accessor: 'accessCount'},
      {Header: 'Access Limit', id: 'accessLimit', accessor: d => { return d.accessLimit},
        Cell: rowInfo =>(<div>{this.formatAccessLimit(rowInfo.row.accessLimit)}</div>)}
    ]

    this.debouncedSaveColumnWidths = window.debounce(this.saveColumnWidths, 500);
    this.fetchObjectGatewayHistory = this.fetchObjectGatewayHistory.bind(this);

    this.state =
    {
      columns: columns,
      gatewayHistory: [],
      spinnerIsSpinning: false
    }
  }

  async fetchObjectGatewayHistory()
  {
    this.setState({spinnerIsSpinning: true});

    let bodyData = {objectId: this.props.objectId};

    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'getObjectGatewayHistory', bodyData);
    this.setState({spinnerIsSpinning: false});
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error loading object gateway history data');
    this.setState({gatewayHistory: result.jsonData.objectGatewayHistory});
  }

  formatAccessLimit(accessLimit)
  {
    switch (accessLimit)
    {
      case -1:
        return 'Unlimited';

      default:
        return accessLimit;
    }
  }

  formatAccessMode(accessMode)
  {
    switch (accessMode)
    {
      case 'R':
        return 'Read';

      case 'U':
        return 'Read/Write';

      case 'W':
        return 'Write';

      default:
        return 'Read';
    }
  }

  render()
  {
    const override = css`
      display: block;
      margin: 0 auto;
      border-color: red;
    `;

    return(
      <div>
        <Row style={{paddingTop: "10px"}}>
          <Col>
            <ReactTable columns={this.state.columns} data={this.state.gatewayHistory} minRows={1} className="-striped -highlight" 
              onResizedChange={(resizedColumns, event) => this.debouncedSaveColumnWidths(resizedColumns, event)} 
              SubComponent={ data =>
                {
                  return (
                    <div>
                      <ReactTable columns={this.detailColumns} data={data.original.accessDetails} minRows={1} className="-striped -highlight" />
                    </div>
                  );
                }
              }
              />
          </Col>
        </Row>
        <div style={{position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)"}}>
          <RingLoader css={override} size={75} color={'#4A90E2'} loading={this.state.spinnerIsSpinning}/>          
        </div>
      </div>
    );
  }

  saveColumnWidths(resizedColumns)
  {
    this.context.appLocalStorage.saveColumnWidths(resizedColumns, this.columnWidths, this.columnKey);
  }
}

ObjectGatewayHistory.contextType = AppContext;

export default ObjectGatewayHistory
